import { z } from 'zod'

export enum UploadAvatarType {
  SOURCE = 'SOURCE',
  CROPPED = 'CROPPED',
}

const AvatarResizeCoordinatesSchema = z.object({
  x: z.number(),
  y: z.number(),
  scale: z.number(),
})

export const PersonaApiSchema = z.object({
  persona_api: z.object({
    persona_api_avatar_data: z.object({
      original_avatar_url: z.string(),
      resize_avatar_url: z.string(),
      avatar_resize_coordinates: AvatarResizeCoordinatesSchema,
    }),
    persona_api_name: z.string(),
    persona_id: z.number(),
  }),
})

export const SetPersonaApiDataSchema = z.object({
  persona_api_avatar_data: z.object({
    original_avatar_url: z.string(),
    resize_avatar_url: z.string(),
    avatar_resize_coordinates: AvatarResizeCoordinatesSchema,
  }),
  persona_api_name: z.string(),
})

const UploadAvatarTypeEnumSchema = z.nativeEnum(UploadAvatarType)

export const UploadPersonaApiAvatarMultiplePayloadSchema = z.array(
  z.object({
    blob: z.instanceof(Blob),
    uploadType: UploadAvatarTypeEnumSchema,
  }),
)

export const UploadPersonaApiAvatarMultipleFormDataSchema = z.instanceof(FormData)

export const UploadPersonaApiAvatarResponseSchema = z.object({
  attachments: z.record(
    z.object({
      type: z.string(),
      caid: z.number(),
      img_big: z.string(),
      img_small: z.string(),
      title: z.string(),
      image_size: z.object({
        height: z.number(),
        size: z.number(),
      }),
      img_original: z.string(),
      sign: z.string(),
    }),
  ),
})

export type AvatarResizeCoordinates = z.infer<typeof AvatarResizeCoordinatesSchema>
